<div class="paginator-container" fxLayout="row" fxLayoutAlign="flex-end center">
	<div class="go-to-container" fxFlex="1 1 40%" fxLayout="row" fxLayoutAlign="center center">
		<div class="go-to-label" fxFlex="1 1 50%">{{translate.getLng('GO_TO')}}: </div>
		<mat-form-field fxFlex="1 1 40%">
			<mat-select [(ngModel)]="goTo" (selectionChange)="goToChange()">
				<mat-option *ngFor="let pageNumber of pageNumbers" [value]="pageNumber">{{pageNumber}}</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<mat-paginator [length]="length" [hidePageSize]="true" [pageIndex]="pageIndex" [pageSize]="pageSize"
		[pageSizeOptions]="pageSizeOptions" (page)="paginationChange($event)">
	</mat-paginator>
</div>